import { createGlobalStyle } from 'styled-components';

export const HideNextJsLoader = () => {
  return <GlobalStyles />;
};

export default HideNextJsLoader;

const GlobalStyles = createGlobalStyle`
  #nprogress .bar,
  #nprogress .peg,
  #nprogress .spinner,
  #nprogress .spinner-icon {
    display: none;
  }
  `;
